module.exports = __webpack_public_path__ + "img/cii.34bc22b7.png";